import { useEffect, useState } from 'react';
import { getLeadStats } from '../services/adminService';

const statCards = [
  { key: 'totalLeads', label: 'Total leads' },
  { key: 'newLeads', label: 'New leads' },
  { key: 'jobRelatedLeads', label: 'Job related leads' },
  { key: 'serviceRelatedLeads', label: 'Service related leads' },
  { key: 'investmentRelatedLeads', label: 'Investment related leads' },
];

function formatDate(value) {
  if (!value) {
    return 'Not available';
  }

  return new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

function formatEnquiryType(value) {
  return String(value || '')
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

function AdminDashboard() {
  const [state, setState] = useState({ loading: true, error: '', stats: null });

  useEffect(() => {
    getLeadStats()
      .then((data) => setState({ loading: false, error: '', stats: data.stats }))
      .catch(() => setState({ loading: false, error: 'Unable to load lead stats.', stats: null }));
  }, []);

  const stats = state.stats || {};

  return (
    <section className="admin-page">
      <div className="admin-page__header">
        <p className="eyebrow">Dashboard</p>
        <h1>Lead overview</h1>
      </div>

      {state.error ? <p className="form-alert form-alert--error">{state.error}</p> : null}

      <div className="admin-stats-grid">
        {statCards.map((card) => (
          <article className="admin-stat-card" key={card.key}>
            <span>{card.label}</span>
            <strong>{state.loading ? '-' : stats[card.key] || 0}</strong>
          </article>
        ))}
      </div>

      <article className="admin-panel">
        <h2>Latest 5 leads</h2>
        <div className="admin-table">
          {(stats.latestLeads || []).map((lead) => (
            <div className="admin-table__row" key={lead._id}>
              <div>
                <strong>{lead.name}</strong>
                <span>{lead.email}</span>
              </div>
              <span>{formatEnquiryType(lead.enquiryType)}</span>
              <span>{formatDate(lead.createdAt)}</span>
            </div>
          ))}
          {!state.loading && (!stats.latestLeads || stats.latestLeads.length === 0) ? (
            <p className="admin-empty">No leads submitted yet.</p>
          ) : null}
        </div>
      </article>
    </section>
  );
}

export default AdminDashboard;
